import React from 'react';

const STORY_IMAGE = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('769.jpg')}`;

export default function AboutStory(): React.ReactElement {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-8">
          {/* Image Section - Left */}
          <div>
            <div className="relative h-full min-h-[400px] w-full overflow-hidden rounded-xl bg-slate-100 sm:min-h-[450px]">
              <img
                src={STORY_IMAGE}
                alt="Ancient Engineering"
                className="h-full w-full object-cover object-center"
                loading="lazy"
                onError={(e) => {
                  console.error('Failed to load image:', STORY_IMAGE);
                }}
                onLoad={() => {
                  console.log('AboutStory image loaded successfully:', STORY_IMAGE);
                }}
              />
            </div>
          </div>

          {/* Text Content Section - Right */}
          <div className="flex flex-col justify-center">
            <div className="text-left">
              <h2 className="text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl">
                Our Story & Heritage
              </h2>
              <p className="mt-6 text-[13.5px] leading-relaxed text-slate-600 sm:text-[15.5px]">
                Founded on the principles of entrepreneurship and excellence, Ancient Engineering serves
                as a critical partner in Zimbabwe's industrial supply chain. We recognized a need for an
                engineering firm that combines high-level technical agility with the affordability required
                in today's market. By focusing on value addition and market-focused strategies, we help our
                clients optimize their operations while contributing to national employment and industrial growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

